import React from 'react';
import { IMAGE_PATHS } from '../config/images';

const TAGS = [
  {
    key: 'morosil',
    name: 'Morosil',
    desc: 'Auxilia na queima da gordura localizada, especialmente na região abdominal.',
    price: 'R$ 150,00'
  },
  {
    key: 'faseolamina',
    name: 'Faseolamina',
    desc: 'Reduz a absorção de carboidratos sem precisar cortar tudo do cardápio.',
    price: 'R$ 65,00'
  },
  {
    key: 'ltriptofano',
    name: 'L-Triptofano',
    desc: 'Controla a ansiedade e a compulsão alimentar.',
    price: 'R$ 100,00'
  },
  {
    key: 'slendesta',
    name: 'Slendesta',
    desc: 'Aumenta a saciedade e ajuda você a comer menos naturalmente.',
    price: 'R$ 230,00'
  },
  {
    key: 'cromo',
    name: 'Cromo',
    desc: 'Regula o açúcar no sangue e reduz a vontade de comer doce.',
    price: 'R$ 50,00'
  }
];

const CostSection = () => {
  const scrollToOffer = () => {
    const offer = document.getElementById('offer');
    if (offer) offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="valor-ativos" className="mgs-cost">
      <div className="mgs-cost__inner">
        <h2 className="mgs-cost__title">
          Mas afinal, quanto<br />
          <span className="mgs-cost__title-gold">você gastaria</span> se comprasse<br />
          cada ativo do MagriSim separadamente?
        </h2>

        {/* Diagrama: frasco + ativos em volta (componentes.png) com textos sobrepostos */}
        <div className="mgs-cost__diagram">
          <img
            src={IMAGE_PATHS.componentes}
            alt="Frasco do MagriSim e seus ativos: Morosil, Faseolamina, L-Triptofano, Slendesta e Cromo"
            className="mgs-cost__img"
          />

          {TAGS.map((t) => (
            <div key={t.key} className={`mgs-cost__tag mgs-cost__tag--${t.key}`}>
              <span className="mgs-cost__tag-name">{t.name}</span>
              <span className="mgs-cost__tag-desc">{t.desc}</span>
              <span className="mgs-cost__tag-price">({t.price})</span>
            </div>
          ))}
        </div>

        {/* Total + chamada + CTA */}
        <div className="mgs-cost__total">
          <i className="fas fa-shopping-cart"></i>
          <span className="mgs-cost__total-label">Total de</span>
          <strong className="mgs-cost__total-value">R$ 595,00</strong>
        </div>

        <p className="mgs-cost__pitch">
          Leve tudo isso hoje por{' '}
          <span className="mgs-cost__pitch-line2">
            menos de <strong>R$4,00</strong> por dia.
          </span>
        </p>

        <button className="mgs-cost__cta" onClick={scrollToOffer}>
          QUERO EMAGRECER AGORA
          <i className="fas fa-arrow-right"></i>
        </button>
      </div>
    </section>
  );
};

export default CostSection;
